var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelGoogleplus14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M4.5 4c.907 0 1.733.345 2.355.911-.732.692-.708.733-.996 1.02-.36-.297-.752-.51-1.359-.51-1.148 0-2.045.93-2.045 2.079 0 1.148.897 2.08 2.045 2.08 1.135 0 1.596-.49 1.892-1.389H5.46l-.147.001h-.7l-.06.001H4.5V6.807h3.361C8.096 8.484 7.39 11 4.5 11a3.5 3.5 0 0 1 0-7m6.516 2v1h1.004v1.015h-1.004V9h-.985v-.985H9.014V7.001h1.017V6z"
}))));
export default SvgChannelGoogleplus14;